import { ClientInfoT } from "../../../models/models";
import {
  AccessLevelE,
  ClientCurrencyE,
  ClientSubtypeE,
  ClientTypeE,
  CountryE,
  CultureE,
  LangE,
  UserRoleE,
  UserStatusE,
} from "./../../../models/enums";
export type FetchTokensParamsT<T extends FetchTokensGrantTypeE> =
  T extends FetchTokensGrantTypeE.PASSWORD
    ? {
        username: string;
        password: string;
        recaptcha_token: string;
      }
    : T extends FetchTokensGrantTypeE.REFRESH_TOKEN
    ? { refresh_token: string }
    : never;

export type FetchTokensReturnT = {
  access_token?: string;
  refresh_token?: string;
  expires_in?: number;
  token_type?: string | "bearer";
  error?: string;
  error_description?: string;
};

export type TokensT = {
  access_token: string;
  refresh_token: string;
};

export type FetchTokensT = (FetchTokensArgsI) => FetchTokensReturnT;

export enum FetchTokensGrantTypeE {
  REFRESH_TOKEN = "refresh_token",
  PASSWORD = "password",
}

export interface ClientUserDataReturnT {
  Id: number;
  real_id: string;
  Name: null | string;
  AdId: null | string;
  ClientType: ClientTypeE;
  ClientSubType: ClientSubtypeE;
  Culture: CultureE | null;
  Country: CountryE | null;
  Address: null | string;
  ImageSource: string | null;
  EditingEnabled: boolean;
  Email: string | null;
  HasUser: boolean;
  IsContentManager: boolean;
  ClientInfo: ClientInfoT | null;
  ClientCurrency: ClientCurrencyE;
}

export interface UserDataReturnT {
  Id: string;
  UserName: string;
  Email: string;
  FirstName: string;
  LastName: string;
  JobTitle: null | string;
  MobilePhoneNumber: null | string;
  PhoneNumber: null | string;
  RegistrationDateTime: string;
  LastLoginDateTime: string;
  Culture: "en-US" | "he-IL";
  IsClientContact: boolean;
  OnlyMyProjects: boolean;
  Password: null | string;
  ConfirmPassword: null | string;
  AccessLevel: AccessLevelE;
  IsActive: boolean;
  ActiveAdditionalRecipients: string;
  NonActiveAdditionalRecipients: string;
  Status: UserStatusE;
  DisabledNotificationEmails: null | string;
  ClientId: null | number;
  isUseFtp: boolean;
  EmailConfirmed: boolean;
  ContactInfoConfirmed: boolean;
}

export type FetchUserDataReturnUserT = {
  AdId: string;
  id: number;
  userId: string;
  userName: string;
  role: UserRoleE;
  clientType: ClientTypeE;
  accessLevel: AccessLevelE;
  culture: CultureE;
  email: string;
  EmailConfirmed: boolean;
  ContactInfoConfirmed: boolean;
  ClientCurrency: ClientCurrencyE;
  profilePhoto: string;
  refreshToken: string;
};

export type FetchUserDataReturnT = [
  {
    user: FetchUserDataReturnUserT | null;
  },
  LangE
];
